import { render, staticRenderFns } from "./AccountProfileSettingsEditInfo.vue?vue&type=template&id=24a05346&"
import script from "./AccountProfileSettingsEditInfo.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSettingsEditInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports